import { render, staticRenderFns } from "./UploadScan.vue?vue&type=template&id=8e722078"
import script from "./UploadScan.vue?vue&type=script&lang=js"
export * from "./UploadScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports